import GenericError from './GenericError';

export default GenericError;
